/** Default shape for Add New Product — every field defined so inputs stay controlled. */
export const EMPTY_NEW_PRODUCT = {
  name: '',
  description: '',
  shortDescription: '',
  originalPrice: '',
  salePrice: '',
  mainCategory: '',
  category: '',
  subcategory: '',
  childrenCategory: '',
  brand: '',
  sku: '',
  url: '',
  productId: '',
  colors: [],
  sizes: [],
  images: [],
  stock: {},
  tags: [],
  features: [],
  specifications: {},
  isFeatured: false,
  isNew: false,
  isOnSale: false,
  isActive: true,
  status: 'active',
  weight: '',
  dimensions: { length: '', width: '', height: '' },
  saleEndDate: '',
};
